// LUMINA · components/CredentialApplication.jsx
// 用户申请灌顶资质 — 选择资质 key → 填灌顶信息 → 提交

import React, { useState, useEffect } from 'react';
import { API, GD, TXT2, VAJRA_T } from '../constants';

export default function CredentialApplication({ token, member, lang }) {
  const T = VAJRA_T[lang] || VAJRA_T.zh;
  const [keys,      setKeys]      = useState([]);
  const [apps,      setApps]      = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [form,      setForm]      = useState({ credential_key: "", label_zh: "", initiation_date: "", initiation_place: "", initiation_teacher: "", initiation_teacher_id: "", notes: "" });
  const [msg,       setMsg]       = useState("");
  const [submitted, setSubmitted] = useState(false);

  const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };

  useEffect(() => {
    Promise.all([
      fetch(`${API}/vajra/credentials/keys`).then(r => r.json()),
      fetch(`${API}/vajra/me/applications`, { headers }).then(r => r.json()),
    ]).then(([keysData, appsData]) => {
      setKeys(keysData.keys || []);
      setApps(Array.isArray(appsData) ? appsData : []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.credential_key) { setMsg(T.credApplyNoKey); return; }
    const body = { ...form, initiation_teacher_id: form.initiation_teacher_id ? parseInt(form.initiation_teacher_id) : null };
    if (!body.initiation_teacher_id) delete body.initiation_teacher_id;
    const r = await fetch(`${API}/vajra/me/apply-credential`, { method: "POST", headers, body: JSON.stringify(body) });
    if (r.ok) {
      setMsg(T.credApplyOk);
      setSubmitted(true);
      const newApps = await fetch(`${API}/vajra/me/applications`, { headers }).then(r => r.json());
      setApps(Array.isArray(newApps) ? newApps : []);
    } else {
      const d = await r.json().catch(() => ({}));
      setMsg("✗ " + (d.detail || T.credApplyFail));
    }
  };

  const STATUS = { pending: T.credApplyPending, approved: T.credApplyApproved, rejected: T.credApplyRejected };
  const STATUS_COLOR = { pending: "#d97706", approved: "#059669", rejected: "#dc2626" };

  if (loading) return <div style={{ fontSize: 12, color: "#ccc", textAlign: "center", padding: "20px 0" }}>{T.loading}</div>;

  return (
    <div>
      <div style={{ fontSize: 13, color: GD, fontWeight: 600, marginBottom: 8 }}>{T.credApplyTitle}</div>
      <div style={{ fontSize: 11, color: TXT2, marginBottom: 16 }}>{T.credApplyDesc}</div>

      {/* Application form */}
      {!submitted ? (
        <form onSubmit={submit} style={{ padding: "12px 14px", background: "rgba(139,105,20,0.04)", borderRadius: 10, border: "1px solid rgba(212,175,55,0.15)", marginBottom: 20 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            <div>
              <div style={{ fontSize: 10, color: "#999", marginBottom: 3 }}>{T.credApplySelect}</div>
              <select value={form.credential_key} onChange={e => {
                const k = keys.find(k => k.key === e.target.value);
                setForm(f => ({ ...f, credential_key: e.target.value, label_zh: k?.label_zh || "" }));
              }} style={inp}>
                <option value="">{T.credApplySelectPlaceholder}</option>
                {keys.map(k => <option key={k.key} value={k.key}>{k.label_zh} ({k.key})</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 10, color: "#999", marginBottom: 3 }}>{T.credApplyDate}</div>
              <input type="date" value={form.initiation_date} onChange={e => setForm(f => ({ ...f, initiation_date: e.target.value }))} style={inp} />
            </div>
            <div>
              <div style={{ fontSize: 10, color: "#999", marginBottom: 3 }}>{T.credApplyPlace}</div>
              <input value={form.initiation_place} onChange={e => setForm(f => ({ ...f, initiation_place: e.target.value }))} placeholder={T.credApplyPlacePlaceholder} style={inp} />
            </div>
            <div>
              <div style={{ fontSize: 10, color: "#999", marginBottom: 3 }}>{T.credApplyTeacher}</div>
              <input value={form.initiation_teacher} onChange={e => setForm(f => ({ ...f, initiation_teacher: e.target.value }))} placeholder={T.credApplyTeacherPlaceholder} style={inp} />
            </div>
          </div>
          <div style={{ marginTop: 8 }}>
            <div style={{ fontSize: 10, color: "#999", marginBottom: 3 }}>{T.credApplyNotes}</div>
            <textarea value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} placeholder={T.credApplyNotesPlaceholder} rows={2} style={{ ...inp, resize: "vertical", width: "100%" }} />
          </div>
          {msg && <div style={{ fontSize: 11, color: msg.startsWith("✓") ? "#059669" : "#c0392b", marginTop: 8 }}>{msg}</div>}
          <button type="submit" style={{ marginTop: 10, padding: "7px 20px", background: GD, color: "#fff", border: "none", borderRadius: 7, fontSize: 12, cursor: "pointer" }}>{T.credApplySubmit}</button>
        </form>
      ) : (
        <div style={{ padding: "12px 14px", background: "rgba(6,78,59,0.06)", borderRadius: 10, border: "1px solid rgba(6,78,59,0.15)", marginBottom: 20, textAlign: "center" }}>
          <div style={{ fontSize: 13, color: GD }}>{T.credApplySubmitted}</div>
          <button onClick={() => setSubmitted(false)} style={{ marginTop: 8, padding: "4px 14px", background: "none", border: "1px solid rgba(139,105,20,0.3)", borderRadius: 6, color: GD, fontSize: 11, cursor: "pointer" }}>{T.credApplyAgain}</button>
        </div>
      )}

      {/* Application history */}
      {apps.length > 0 && (
        <div>
          <div style={{ fontSize: 11, color: "#999", marginBottom: 8, letterSpacing: 1 }}>{T.credApplyHistory}</div>
          {apps.map(a => (
            <div key={a.id} style={{ padding: "8px 12px", marginBottom: 6, borderRadius: 8, background: "rgba(0,0,0,0.02)", border: "1px solid rgba(0,0,0,0.06)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 12, color: "#333" }}>{a.label_zh} ({a.credential_key})</span>
                <span style={{ fontSize: 11, color: STATUS_COLOR[a.status], fontWeight: 600 }}>{STATUS[a.status]}</span>
              </div>
              {a.initiation_date && <div style={{ fontSize: 10, color: TXT2, marginTop: 2 }}>{T.credApplyStatusLabel} {a.initiation_date}</div>}
              {a.review_notes && <div style={{ fontSize: 10, color: "#888", marginTop: 2 }}>{T.credApplyReviewLabel} {a.review_notes}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const inp = { width: "100%", padding: "6px 9px", borderRadius: 6, border: "1px solid rgba(0,0,0,0.12)", fontSize: 12, boxSizing: "border-box", background: "#fff" };
